export function numberFormat(number, opts) {
  const formatter = new Intl.NumberFormat('sv-SE', opts);
  return formatter.format(number);
}
